import dynamic from 'next/dynamic';
const EventIcon = dynamic(() => import('./EventIcon'));

export default EventIcon;
